import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface UploadProgressDialogProps {
  open: boolean;
  uploadStatus: {
    video: boolean;
    audio: boolean;
  };
  progress?: number; // 0-100
}

export function UploadProgressDialog({ open, uploadStatus, progress }: UploadProgressDialogProps) {
  const getUploadMessage = () => {
    if (uploadStatus.video && uploadStatus.audio) {
      return "Uploading video and audio...";
    }
    if (uploadStatus.video) {
      return "Uploading video...";
    }
    if (uploadStatus.audio) {
      return "Uploading audio...";
    }
    return "Processing...";
  };

  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Loader2 className="h-5 w-5 animate-spin text-primary" />
            Upload in Progress
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-4">
            <p className="text-base font-medium text-foreground">
              {getUploadMessage()}
            </p>
            <Progress value={progress ?? 0} className="w-full" />
            <p className="text-sm font-medium text-foreground">
              {progress !== undefined ? `${Math.round(progress)}% complete` : 'Starting upload...'}
            </p>
            <p className="text-sm text-muted-foreground">
              Please wait while we upload your response. Do not close this window or navigate away.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  );
}
